/* @flow */

import type { RootState, CustomerId } from '../../types'

type Action = {
  type: string,
  payload: CustomerId,
}

export const SELECT_CUSTOMER_VIEW = 'opinary/selectCustomerView'
export function selectCustomer(customerId: CustomerId = ''): Action {
  return {
    type: SELECT_CUSTOMER_VIEW,
    payload: customerId,
  }
}

export function getSelectedCustomerId(state: RootState): ?CustomerId {
  return state.ui.selectedCustomer
}

export default function reducer(
  state: ?CustomerId = null,
  { type, payload }: Action
) {
  switch (type) {
    case SELECT_CUSTOMER_VIEW:
      return payload
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/ui/selectedCustomer.js